import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { Pricing } from '@setvi/shared/interfaces';

interface CostProps {
  value: number;
  label: Pricing['label'];
}

export const Cost = ({ label, value }: CostProps) => (
  <SText
    title={`${label}: ${
      value > 0
        ? value.toLocaleString('en-US', {
            currency: 'USD',
            style: 'currency'
          })
        : '-'
    }`}
    fontColor={TextColor.DarkGrey}
  />
);
